{
  "jira.side.nav.onboarding.import.nudge.heading": [
    {
      "type": 0,
      "value": "Import work from another tool or CSV file to get started faster."
    }
  ],
  "jira.side.nav.onboarding.import.nudge.icon.alt": [
    {
      "type": 0,
      "value": "Lightbulb icon indicating an import tooltip"
    }
  ],
  "jira.side.nav.onboarding.import.nudge.link": [
    {
      "type": 0,
      "value": "Import work"
    }
  ],
  "jira.side.nav.onboarding.invite.nudge.heading": [
    {
      "type": 0,
      "value": "Invite your team to collaborate on work together."
    }
  ],
  "jira.side.nav.onboarding.invite.nudge.icon.alt": [
    {
      "type": 0,
      "value": "Invite icon indicating an invite tooltip"
    }
  ],
  "jira.side.nav.onboarding.invite.nudge.link": [
    {
      "type": 0,
      "value": "Invite your team"
    }
  ]
}